import { FormikProps } from 'formik';
import * as React from 'react';
import { SearchRequestTypes } from '../../../../components/muiLegacy/Tables/KeywordTable/ToolbarButtons/AddKeywords/AddBasicKeywords/logic/SearchModels';
import VoxelInput from '../../../../components/voxel/Forms/VoxelInput';
import VoxelTextarea from '../../../../components/voxel/Forms/VoxelTextArea';
import SearchInfoTooltipContent from '../../../../components/voxel/Tooltip/Content/SearchInfoTooltipContent';
import { GoogleAdsRequestTypeGq } from '../../../../graphql/projects/models/GoogleAdsRequestTypeGq';
import { replaceTabsWithLinebreaks } from '../../../../logic/otherUtilities/replaceTabsWithLinebreaks';
import { CreateQuickSearchFormState } from './QuickSearchForm/logic/QuickSearchModels';

export interface SearchTypeInputFieldsProps {
  formik: FormikProps<CreateQuickSearchFormState>;
  readOnly?: boolean;
  disabled?: boolean;
}

const SearchTypeInputFields: React.FC<SearchTypeInputFieldsProps> = ({
  formik,
  readOnly,
  disabled,
}) => {
  let label = 'Keywords';
  if (formik.values.requestType === GoogleAdsRequestTypeGq.URL) {
    label = 'Urls';
  }
  if (formik.values.requestType === GoogleAdsRequestTypeGq.SITE) {
    label = 'Domain';
  }

  return (
    <div className="w-full">
      {SearchRequestTypes.map((item) => (
        <div key={item.name}>
          {formik.values.requestType === item.type &&
            formik.values.requestType === GoogleAdsRequestTypeGq.SITE && (
              <VoxelInput
                id={formik.values.requestType}
                value={formik.values.source}
                onChange={(event) => {
                  let processedValue = replaceTabsWithLinebreaks(event.target.value);
                  formik.setFieldValue('source', processedValue);
                }}
                readOnly={readOnly}
                label={label}
                labelPosition='top'
                deleteValue={readOnly ? undefined : () => formik.setFieldValue('source', replaceTabsWithLinebreaks(''))}
                placeholder={item.placeholder}
                disabled={formik.isSubmitting || disabled}
              />
            )}
          {formik.values.requestType === item.type && formik.values.requestType !== GoogleAdsRequestTypeGq.SITE && (
            <VoxelTextarea
              readOnly={readOnly}
              label={label}
              id={formik.values.requestType}
              value={formik.values.source}
              onChange={(event) => {
                let processedValue = replaceTabsWithLinebreaks(event.target.value);
                formik.setFieldValue('source', processedValue);
              }}
              deleteValue={readOnly ? undefined : () => formik.setFieldValue('source', replaceTabsWithLinebreaks(''))}
              placeholder={item.placeholder}
              minRows={formik.values.requestType === GoogleAdsRequestTypeGq.LONG_TAIL ? 2 : 4}
              maxLength={formik.values.maxCharacters}
              disabled={formik.isSubmitting || disabled}
              inputCount={formik.values.source?.trim()?.split(/[\n,]+/g).length + ' keyword seeds'}
              infoText={<SearchInfoTooltipContent />}
              errorText={formik.errors.source}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SearchTypeInputFields;
